import { Component } from '@angular/core';
import { ListadoListadoCategoriasComponent } from '../../../../standalone/listado-categorias/listado-listado-categorias/listado-listado-categorias.component';

/**
 * Síntomas y diagnósticos: categorías 'Sintomas' / 'Diagnosticos' del listado
 * genérico de categorías (se muestran como "Síntomas" / "Diagnósticos").
 */
@Component({
  selector: 'app-listado-categorias-medicas',
  imports: [ListadoListadoCategoriasComponent],
  templateUrl: './listado-categorias-medicas.component.html',
})
export class ListadoCategoriasMedicasComponent {}
